import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";
const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};

function SAMPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Materials and Methods</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              <strong>Study Area</strong>
            </p>

            <p style={{ textAlign: "center" }}>
              <img src="images/gv1.png" alt="" />
            </p>
            <p style={{ textAlign: "center" }}>
              <strong>Fig.1</strong> Study area - Mumbai Pune expressway (MPEW)
            </p>
            <p>
              Mumbai Pune expressway (MPEW) also known as Yashwantrao Chavan
              express way is a 6 lane express way for a distance of 94 between
              Shil Phata -Navi Mumbai to Dehu Road &ndash;Pune. MPEW is the
              first six lane highway built in India with Public Private
              Partnership Model connecting Mumbai &ndash; the business capital
              of India and Pune &ndash; cultural capital and education hub of
              Maharashtra in the year 2000 (Mumbai-Pune Expressway, India,
              2018). The Expressway has five interchanges and six tunnels
              covering an approximate length of 5.6km. MPEW was planned to i)
              reduce the traffic congestion along the national highway 4
              connecting Mumbai and Pune, ii) reduce accidents and mortality,
              iii) increase business and trade potential, iv) reduce transit
              time of resources, <em>etc.</em> In the current study we consider
              MPEW and major connecting between MPEW and City centers i.e.,
              about distance of 135 km with a buffer zone of 10 km on either
              sides to understand the role of industrial corridors on land use
              changes in the region. The study region (Fig.1) consists of Mumbai
              Pune expressway (MPEW) between 18&deg; 25&rsquo; N to
              19&deg;10&rsquo; N and 72&deg; 46&rsquo;E to 73&deg; 56&rsquo;E
              with 5 km buffer on either side of the expressway (region of 3022
              sq.km)&nbsp; passing through the districts of Mumbai, Thane,
              Raigarh and Pune.
            </p>
            <p>
              <strong>&nbsp;</strong>
            </p>
            <p>
              <strong>Data and Method</strong>
            </p>
            <p>
              Fig. 2 elucidates the method opted for understanding landscape
              dynamics along the industrial corridors. The process involved i)
              data acquisition and data preprocessing; ii) land cover
              assessment; ii) land use assessment through supervised classifier
              using GMLC (Gaussian Maximum Likelihood Classifier); iv) Spatial
              pattern analyses at micro levels through spatial metrics, v)
              modeling and prediction of future landscape transitions using rule
              and agent based models.
            </p>
            <p style={{ textAlign: "center" }}>
              <img src="images/gv2.png" alt="" />
            </p>
            <p style={{ textAlign: "center" }}>
              <strong>Fig.2</strong> Method for landscape dynamics analyses
            </p>
            <p>Data acquisition and preprocessing</p>
            <p>
              The process of data acquisition involves collection of primary and
              secondary data. Primary data includes collection of remote sensing
              data and field data. Remote sensing data &nbsp;(RS) &nbsp;for the
              period 1997 -2015 were downloaded from USGS (United States
              Geological Survey. 2015a, 2015b; http://landsat.usgs.gov). Table 1
              tabulates various data sets acquired for analysis. GPS based field
              surveys were done in order to supplement land use analysis for
              2009 and 2015. Secondary Data collection involves collection of
              ancillary data such a French Institute Puducherry
              (http://www.ifpindia.org) vegetation maps (Pascal, 1982) and the
              Survey of India topographic maps (The Geological Survey of India;
              http://surveyofindia.gov.in)&nbsp; supplemented with the virtual
              spatial data such as Google earth (Google 2016;
              http://earth.google.com) and Bhuvan (National Remote Sensing
              Centre, 2016; http://bhuvan.nrsc.gov.in). The secondary data
              provides additional input to the field data for data
              pre-processing and classification. Data preprocessing involved
              radiometric and geometric corrections of remote sensing data.
            </p>
            <p>
              <strong>Table 1</strong> Satellite data used in the analysis
            </p>
            <table align="center" width="100%">
              <tbody>
                <tr>
                  <td style={styles.cell} width="58%">
                    <p>Data</p>
                  </td>
                  <td style={styles.cell} width="17%">
                    <p>Year</p>
                  </td>
                  <td style={styles.cell} width="23%">
                    <p>Spatial Resolution</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="58%">
                    <p>Landsat 8 &ndash; Operational Land Imager</p>
                  </td>
                  <td style={styles.cell} width="17%">
                    <p>2015</p>
                  </td>
                  <td style={styles.cell} width="23%">
                    <p>30 m</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="58%">
                    <p>Landsat 8 &ndash; Operational Land Imager</p>
                  </td>
                  <td style={styles.cell} width="17%">
                    <p>2009</p>
                  </td>
                  <td style={styles.cell} width="23%">
                    <p>30 m</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="58%">
                    <p>Landsat 5 - Thematic Mapper</p>
                  </td>
                  <td style={styles.cell} width="17%">
                    <p>2003</p>
                  </td>
                  <td style={styles.cell} width="23%">
                    <p>30 m</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="58%">
                    <p>Landsat 7 -&nbsp; Enhanced Thematic Mapper Plus</p>
                  </td>
                  <td style={styles.cell} width="17%">
                    <p>1997</p>
                  </td>
                  <td style={styles.cell} width="23%">
                    <p>30 m</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>Land cover</p>
            <p>
              Land cover refers to physical cover of the earth surface that
              essentially indicates the spatial extent of vegetation present on
              the land surface. Land cover assessment is carried out to estimate
              overall vegetation cover as against non-vegetation. Vegetation
              cover included Forests, Current Sown crops, Grasslands, and all
              other forms of vegetation in the area. Normalized Difference
              Vegetation Index (NDVI) (Burrough 1986; Lillesand et al. 2004), a
              widely used index (Hatfield and Prueger 2010, Agapiou et al. 2012,
              Ramachandra et al. 2013) was used to quantify vegetation cover
              along the corridor. Temporal vegetation dynamics was assessed by
              computing NDVI across time.
            </p>
            <p>Land use</p>
            <p>
              Land use relates to human activity/economic activity on piece of
              land under consideration (Ramachandra and Bharath 2012). This
              analysis provides various uses of land as urban, agriculture,
              forest, plantation, etc., specified as per USGS classification
              system and National Remote Sensing Centre, India. The land use
              analyses using multi spectral remote sensing data (Ramachandra and
              Bharath 2012) involved (i) generation of False Color Composite
              (FCC) of RS data (bands&ndash;green, red and NIR). This composite
              image helps in locating heterogeneous patches in the landscape,
              (ii) selection of training polygons by covering 15% of the study
              area (polygons are uniformly distributed over the entire study
              area) (iii) loading these training polygons co-ordinates into
              pre-calibrated GPS, (vi) collection of the corresponding attribute
              data (land use types) for these polygons from the ﬁeld, (iv)
              supplementing this information with virtual earth data (Google
              earth/Bhuvan) and (v) 60% of the training data has been used for
              classiﬁcation based on Gaussian Maximum Likelihood algorithm,
              while the balance is used for validation or accuracy assessment.
              &nbsp;The land use analysis was done using a supervised
              classification technique based on Gaussian maximum likelihood
              algorithm with training data and this technique is proved to be
              one of the best probabilistic land use classification algorithm
              (Bharath et al. 2014; Jensen 1996; Lillesand et al. 2004;
              Ramachandra et al. 2013, 2017; Ramachandra et al. 2016; Sabin
              1997). Mean and covariance matrix are computed using estimate of
              maximum likelihood estimator. Accuracy assessment to evaluate the
              performance of&nbsp;classifiers was done&nbsp;with the help of
              field data by testing the statistical significance of a
              difference, computation of kappa coefficients and proportion of
              correctly allocated cases (Ramachandra and Bharath 2012). Recent
              remote sensing data (2015) was classified using the collected
              training samples. Statistical assessment of classifier performance
              based on the performance of spectral classification considering
              reference pixels is done which include computation of kappa
              (&kappa;) statistics and overall (producer's and user's)
              accuracies. For earlier time data, training polygon along with
              attribute details were compiled from the historical published
              topographic maps, vegetation maps, revenue maps, etc.
            </p>
            <p>
              <strong>Table 2</strong> Land use categories
            </p>
            <table align="center">
              <tbody>
                <tr>
                  <td style={styles.cell} width="96">
                    <p>Class</p>
                  </td>
                  <td style={styles.cell} width="528">
                    <p>Features</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="96">
                    <p>Water</p>
                  </td>
                  <td style={styles.cell} width="528">
                    <p>
                      River, Reservoir, Check dams, Streams, Lakes, Ponds,
                      Ocean, Estuary, <em>etc.</em>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="96">
                    <p>Vegetation</p>
                  </td>
                  <td style={styles.cell} width="528">
                    <p>
                      Forest, Avenue trees, Parks, Gardens, Current sown
                      (agriculture), Mangroves, Macrophytes, <em>etc</em>.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="96">
                    <p>Built up</p>
                  </td>
                  <td style={styles.cell} width="528">
                    <p>
                      Buildings, Roads, Industries, Layouts, Concrete and Paved
                      Surfaces, <em>etc.</em>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="96">
                    <p>Others</p>
                  </td>
                  <td style={styles.cell} width="528">
                    <p>
                      Open lands, Current fallow (agriculture), Quarries,{" "}
                      <em>etc.</em>
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>&nbsp;</p>
            <p>
              Spatial patterns of urbanisation through landscape metrics at
              micro levels
            </p>
            <p>
              Landscape metrics aid in capturing inherent spatial structure of
              landscape pattern and biophysical characteristics of spatial
              change dynamics. Landscape metrics such as patch size and patch
              shape have been used widely to convey meaningful information on
              biophysically changed phenomena associated with patch
              fragmentation at a large scale (McGarial and Marks 1995;
              Ramachandra et al. 2012; Bharath and Ramachandra 2016).
              Heterogeneity-based indices have evolved to quantify the spatial
              structures and organization within the landscape. Quantification
              of spatial patterns of urbanization has been done by combining
              landscape metrics with linear gradient analysis, which helps in
              capturing the spatial variation of land use patterns along a
              predefined direction. Thus, landscape metrics are important
              indicators of the growth patterns, neighborhood effect at a
              temporal scale and help in understanding the spatial patterns of
              urban dynamics at micro level (zones) along the corridor with
              insights to the landscape configuration and interaction between
              urban and neighboring land uses.&nbsp; MPEW with buffer region (5
              km on either side of MPEW) was divided into zones of 25 km width
              (Fig. 3) between Mumbai to Pune. These zonal gradients provide the
              information of neighborhood changes at local levels. Spatial
              metrics were computed for each zone to understand the spatial
              patterns of urban dynamics based on composition, configuration
              pattern and spread at local levels (Bharath and Ramachandra 2016;
              Gkyer 2013; McGarial and Marks 1995; Ramachandra et al. 2012).
              Spatial Metrics prioritized based on earlier studies (Bharath and
              Ramachandra 2016; Ramachandra et al. 2012) were considered and are
              listed in Table 3.
            </p>
            <p>
              <strong>Table 3</strong> Spatial Metrics
            </p>
            <table align="center">
              <tbody>
                <tr>
                  <td style={styles.cell}>
                    <p>Metrics</p>
                  </td>
                  <td style={styles.cell}>
                    <p>Equation</p>
                  </td>
                  <td style={styles.cell}>
                    <p>Range</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>Patch density</p>
                    <p>(PD)</p>
                    <p>
                      <strong>&nbsp;</strong>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>&nbsp;</p>
                    <p>
                      <em>f</em>(sample area) = (Patch Number/Area) * 1000000
                    </p>
                    <p>
                      <strong>&nbsp;</strong>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>PD&gt;0,</p>
                    <p>without limit</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>Largest Patch</p>
                    <p>Index</p>
                    <p>(LPI)</p>
                  </td>
                  <td style={styles.cell}>
                    <p style={{ textAlign: "center" }}>
                      <img src="images/gv_formula1.png" alt="" />
                    </p>
                    <p>
                      &nbsp;A<sub>ij</sub> = area of patch i belonging to class
                      j
                    </p>
                    <p>A = Total Landscape Area</p>
                  </td>
                  <td style={styles.cell}>
                    <p>0 &le; LPI &le; 100</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>Total Edge</p>
                    <p>(TE)</p>
                  </td>
                  <td style={styles.cell}>
                    <p style={{ textAlign: "center" }}>
                      <img src="images/gv_formula2.png" alt="" />
                    </p>
                    <p>
                      e<sub>ik</sub> = total length of edge in landscape
                      involving patch type k
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>
                      TE &ge; 0, without limit. TE = 0 when there is no class
                      edge.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>Percentage of Landscape</p>
                    <p>(PLAND)</p>
                  </td>
                  <td style={styles.cell}>
                    <p style={{ textAlign: "center" }}>
                      <img src="images/gv_formula3.png" alt="" />
                    </p>
                    <p>
                      A<sub>ij</sub> = Area of Patch i belonging to class j.
                    </p>
                    <p>A= Total Landscape Area</p>
                  </td>
                  <td style={styles.cell}>
                    <p>0 &le; PLAND &le; 100</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>&nbsp;</p>
            <p style={{ textAlign: "center" }}>
              <img src="images/gv3.png" alt="" />
            </p>
            <p style={{ textAlign: "center" }}>
              <strong>Fig.3</strong> Zonal approach for understanding sprawl at
              local levels
            </p>
            <p>Land use Modeling and Prediction</p>
            <p>
              Land-use change models are inherent to uncertainties due to
              limited knowledge of the complexity of urban system. In the
              current work, uncertainty is addressed through calibration by
              performing sensitivity analysis, wherein, the model is run with
              different parameter values and the results are validated.
              Prioritized parameters were considered for modelling. The
              validation of the model is done by measuring the accuracy and
              kappa of the simulated result against known observations. The
              agent based models reduce the approximations based on fuzzy rules
              generated.
            </p>
            <p>
              Land use modeling, simulation and prediction of likely changes
              were done through the rule based and agent based modeling
              techniques. Rule based models use set of rules and conditions to
              predict future landscapes. Cellular Automata combined with Markov
              chains were used in the current study to predict landscape
              dynamics (Adhikari and Southworth 2012; Ramachandta et al. 2013;
              Sang et al. 2011). Markov Chains explains the conversion of land
              use from one state to the other through transition probabilities
              based on two-time period land use i.e., historical and current
              state of land use. Cellular Automata (CA) is a spatial modeling
              technique that considers local interaction between neighboring
              cells, transition rules. A kernel of 5 X 5 is used to define the
              neighborhood rules with defined transition cell probabilities and
              current state of each cell. Coupling CA-Markov chains considers
              the transition probabilities obtained from the Markov Process
              which is used as input to CA to model the spatial dynamics i.e.,
              state of pixel is thus calculated as summed effect of each
              transitional potential, interaction with its neighbors and the
              transition rules. &nbsp;In the Current work, transition
              probability areas were evaluated for the year 2009 and 2015, which
              were compared with actual land uses for assessment of prediction
              accuracy and then land uses for the year 2021 and 2027
              respectively were predicted.&nbsp;
            </p>
            <p>
              Agent Based Models (Arsanjani et al. 2013; Bharath et al. 2016,
              2018; Gilbert 2008) evaluate and account various factors and
              constraints of growth to derive site suitability maps which are
              used with CA-Markov to predict future landscape. Google Earth,
              City Development Plans (Pune Municipal Corporation 2012; UDRI
              2014) French Institute Maps were used to digitize features such as
              Airports, City Centers, Bus Stops, Railway Stations, Educational
              Institutions, Industries, Socio-Cultural Structures, Roads, Parks,
              Protected areas, Water bodies respectively. Digital elevation
              model (DEM) from SRTM (United States Geological Survey. 2015a) was
              used to derive Slope. Distance maps were developed for all the
              factors / agents aiding as catalyst in urban growth namely all
              point features and road network. Distance maps were overlaid on
              built up area to understand the magnitude and influence of each of
              the features on built up areas. Based on the range and behavior of
              the feature, distances were normalized (0 to 255) through fuzzy
              techniques. Analytical Hierarchical Process was used to
              prioritize, weigh each of the feature using pairwise comparison
              for built up, others and vegetation land uses. Slope map,
              protected areas were used as constraints for urban development and
              were classified using Boolean algebra i.e., 0 and 1.0 representing
              no change and 1 represents areas where is land us can change.
              Fuzzy maps, constraints and weightages obtained for each factor
              were used to create site suitability maps using multi criteria
              evaluation. Then Markov Chains used to derive transition
              probability between two time data. These transition probabilities
              and site suitability maps used in conjunction with CA to derive
              future urban growth based on suitability.&nbsp; Kappa &nbsp;and
              confusion matrix based accuracy assessment was done to assess the
              relative performance of the techniques (Bharath et al 2014,
              Ramachandra et al 2013, 2017).
            </p>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default SAMPage;
